import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import styles from "@/styles/Process.module.scss";
import classnames from "classnames";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconComplete = function IconComplete(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "30",
      cy: "30",
      r: "30",
      transform: "translate(2 2)",
      fill: "none",
      stroke: "#09f",
      strokeWidth: "3"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.674,33.177,27.1,43.116l18.862-20",
      fill: "none",
      stroke: "#09f",
      strokeWidth: "3",
      fillOpacity: "0"
    })]
  }));
};
IconComplete.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  viewBox: "0 0 64 64"
};
var IconExclamation = function IconExclamation(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(-611 -228)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M29.048,15.844H34.33V36.97H29.048Zm2.641,32.349a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,31.689,48.194Z",
        transform: "translate(611.612 228)",
        fill: "#09f"
      }), /*#__PURE__*/_jsx("g", {
        transform: "translate(611 228)",
        children: /*#__PURE__*/_jsx("g", {
          transform: "translate(0 0)",
          children: /*#__PURE__*/_jsxs("g", {
            fill: "rgba(255,255,255,0)",
            stroke: "#09f",
            strokeWidth: "3",
            children: [/*#__PURE__*/_jsx("circle", {
              cx: "32",
              cy: "32",
              r: "32",
              stroke: "none"
            }), /*#__PURE__*/_jsx("circle", {
              cx: "32",
              cy: "32",
              r: "30.5",
              fill: "none"
            })]
          })
        })
      })]
    })
  }));
};
IconExclamation.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  viewBox: "0 0 64 64"
};
export default function ProcessInformation(_ref) {
  let {
    complete,
    icon,
    header,
    children
  } = _ref;
  const iconType = useMemo(() => {
    if (complete || icon === "complete") return "complete";
    return "excramation";
  }, [complete, icon]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.container, {
      [styles.complete]: complete,
      [styles.information]: !complete
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.header,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.icon,
          children: [iconType === "complete" && /*#__PURE__*/_jsx(IconComplete, {}), iconType === "excramation" && /*#__PURE__*/_jsx(IconExclamation, {})]
        }), /*#__PURE__*/_jsx("h4", {
          className: styles.heading,
          children: header
        })]
      }), children]
    })
  });
}